// require('./bootstrap');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');

    // require('clipboard');

    require('slick-carousel-latest');
} catch (e) {}

import ClipboardJS from "clipboard/dist/clipboard";
// import ApexCharts from 'apexcharts';

import { Fancybox } from "@fancyapps/ui";
Fancybox.defaults.Hash = false;

$(document).ready(function(){

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    let app = {

        loader: null,

        header_search_in_focus: false,

        initialize: function () {

            // $(function () {
            //     $('[data-toggle="tooltip"]').tooltip({
            //         // trigger: 'click', //включить для отладки внешнего вида
            //     })
            // });

            $('.wysiwyg-content').each(function(i, element){
                $(this).find("a[href$='.png'], a[href$='.PNG'], a[href$='.jpg'], a[href$='.JPG'], a[href$='.jpeg'], a[href$='.JPEG'], a[href$='.gif'], a[href$='.GIF'], a[href$='.bmp'], a[href$='.BMP']").attr("data-fancybox", 'gallery_' + i);
            });

            this.loader = document.getElementById('app-loader');

            // инициализируем кнопки копирования в буфер обмена
            if ( ClipboardJS.isSupported() ) {
                let clipboard = new ClipboardJS('.js-btn-clipboard');

                clipboard.on('success', function(e) {
                    $(e.trigger).text( $(e.trigger).data('after-text') );
                    $(e.trigger).addClass('btn-copy_copied');

                    e.clearSelection();

                    setTimeout( function () {
                        $(e.trigger)
                            .removeClass('btn-copy_copied')
                            .text(  $(e.trigger).data('before-text') )
                            .blur();
                    }, 3000 );
                });
            } else {
                $('.js-btn-clipboard').hide();
            }

            //отмечаем как активный пункт, выбранный в сайдбаре при старте страницы
            if($('.sidebar-menu').length) {
                $('.sidebar-menu').find('a[href="' + window.location.hash + '"]').parent().addClass('active');
            }
            this.showTabFromHashUrl()

            this.setUpListeners();

            var HOME_SLIDER = $('.common-slider_1');
            if(HOME_SLIDER.length && HOME_SLIDER.not('.slick-initialized').length) {
                HOME_SLIDER.slick({
                    autoplay: true,
                    autoplaySpeed: 3000,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    adaptiveHeight: true,
                    dots: true,
                    customPaging : function(slider, i) {
                        return '<a href="javascript:void(0)"></a>';
                    },
                    arrows: false,
                    // prevArrow: $('.main-slider .slide-prev'),
                    // nextArrow: $('.main-slider .slide-next')
                });
            }
        },

        loaderShow: function () {
            this.loader.className = 'show';
        },

        loaderHide: function () {
            this.loader.className = '';
        },

        showTabFromHashUrl: function () {
            const hash = window.location.hash;
            if (hash) {
                $('a[data-toggle="tab"][href="' + hash + '"]').tab('show');

                const portfolioTabsNav = $('#portfolio-tabs-nav');
                if ( portfolioTabsNav.length ) {
                    const offsetTop = portfolioTabsNav.offset().top;
                    window.scroll({top: offsetTop, left: 0, behavior: 'smooth' });
                }
            }
        },

        changeHashOnShowTab: function (e) {
            window.location.hash = $(e.target).attr('aria-controls');
        },

        handlePortfolioFeedSize: function() {
            const container = $('#js-portfolio-feed__content-sizer');
            if (container) {
                // при изменении размера окна
                window.addEventListener('resize', app.portfolioFeedSizeExceedDetect);

                // при загрузке страницы
                app.portfolioFeedSizeExceedDetect();
            }
        },

        portfolioFeedSizeExceedDetect: function () {
            const container = $('#js-portfolio-feed__content-sizer').get(0),
                maxHeight = $('#js-portfolio__feed-more-btn').attr('data-step') * 1;

            const descriptionSizeExceeded = ( container.offsetHeight > maxHeight );
            const portfolioFeed = $('#js-portfolio-feed');

            portfolioFeed.toggleClass('portfolio-feed_expanded_always', !descriptionSizeExceeded);
        },

        portfolioFeedShowMore: function () {
            const button = $(this),
                step = button.attr('data-step') * 1,
                current = button.attr('data-current') * 1,
                portfolioFeedContent = $('#js-portfolio-feed__content'),
                portfolioFeed = $('#js-portfolio-feed')
            ;

            const maxHeight = current + step;
            portfolioFeedContent.css({maxHeight: maxHeight});
            button.attr('data-current', maxHeight);
            button.trigger('blur');

            if (maxHeight > $('#js-portfolio-feed__content-sizer').get(0).offsetHeight) {
                portfolioFeed.addClass('portfolio-feed_expanded_total')
            }
        },

        setUpListeners: function () {
            // $('body').on('click', '.sidebar-menu a', function () {
            //     $(this).closest('.sidebar-menu').find('li').removeClass('active');
            //     $(this).parent().addClass('active');
            // });
            $(document).on('click', '#js-header-search__form-button', app.onHeaderSearchFormButtonClick);
            $(document).on('submit', '#js-header-search__form', app.onHeaderSearchFormSubmit);
            // $(document).on('click', '.js-ideas-company-ideas-item__desc-toggle', app.toggleIdeasListItemDesc);
            $(document).on('click', '.js-ideas-company-ideas-list__more-button', app.loadMoreItems);
            $(document).on('click', '.js-brokers-index-list__more-button', app.loadMoreItems);
            $(document).on('click', '.js-list__more-button', app.loadMoreItems);
            $(document).on('click', '.js-idea-rate', app.rateIdea); // голосование за/против за идею
            $(document).on('submit', '.js-poll-form', app.onPollFormSubmit);
            $(document).on('click', '#js-comments-add-button', app.toggleCommentAddForm);
            $(document).on('click', '.js-comments-list-item__add-answer-button', app.toggleCommentAnswerForm);
            $(document).on('click', '.js-feedback-add-button', app.toggleFeedbackAddForm);
            $(document).on('click', '.js-feedback-list-item__add-answer-button', app.toggleFeedbackAnswerForm);

            $(document).on('mouseenter', '.js-rating-stars__star', app.ratingStarMouseEnter);
            $(document).on('mouseleave', '.js-rating-stars__star', app.ratingStarMouseLeave);
            $(document).on('click', '.js-rating-form__star', app.ratingFormStarClick); // рейтинг в форме отзыва
            $(document).on('click', '.js-rating-article__star', app.ratingArticleStarClick); // оценка в статье
            $(document).on('click', '.js-comments-list-item__rate', app.commentRateClick); // оценка комментария
            $(document).on('click', '.js-ipo-votes-bar__button', app.ipoVoteClick); //  голосование  ipo
            $(document).on('click', '.js-etf-votes-bar__button', app.etfVoteClick); //  голосование  etf и других тройных голосований (да, уже, нет)
            $(document).on('click', '#js-etf-fund-show-all', app.showEtfContent);

            $(document).on('input', '#js-brokers-addresses-search-input', app.brokersAddressCitiesSearchGetResults);

            $(document).on('click', '#indexCollapse a', app.onIndexLinkClick);

            $(document).on('click', 'button.js-scroll-to-comments', app.onScrollToCommentsClick);

            $(document).on('show.bs.tab', '#portfolio-tabs-nav a[data-toggle="tab"]', app.changeHashOnShowTab);
            $(document).on('shown.bs.tab', 'a#assets-image-tab', app.handlePortfolioFeedSize);
            $(document).on('click', '#js-portfolio__feed-more-btn', app.portfolioFeedShowMore);

            $(document).on('submit', '#js-brokers-addresses-search-form', function (e) {
                e.preventDefault();
            });

            $('#loginModal').on('shown.bs.modal', function () {
                $('#login-email').trigger('focus')
            })
            $(document).on('click', '#js-modal-auth__go-to-register', function () {
                $('#loginModal').modal('hide')
            })

            $('#registerModal').on('shown.bs.modal', function () {
                $('#register-email').trigger('focus')
            })
            $(document).on('click', '#js-modal-auth__go-to-login', function () {
                $('#registerModal').modal('hide')
            })

            $(document).on('click', '#js-header-search__toggle', function (e) {
                e.preventDefault();
                app.toggleHeaderSearchForm();
            })

            $(document).on('click', '.js-simple-scroller__arrow', app.simpleScrollerArrowClick)

        },

        simpleScrollerArrowClick: function (e) {
            e.preventDefault();

            if ( $(window).width() < 992 ) {
                return false;
            }

            let arrow = $(this),
                direction = arrow.attr('data-direction'),
                step = direction==='next' ? 600 : -600,
                block = arrow.closest('.js-simple-scroller'),
                row = block.find('.js-simple-scroller__scroll'),
                inner = block.find('.js-simple-scroller__inner'),
                rowScrollLeft = row.scrollLeft(),
                rowWidth = row.width();

            row.animate({scrollLeft: rowScrollLeft + step}, 250, 'swing', function() {
                rowScrollLeft = row.scrollLeft()

                $('.js-simple-scroller__arrow_prev').toggleClass( 'simple-scroller__arrow_hidden', rowScrollLeft === 0 )
                $('.js-simple-scroller__arrow_next').toggleClass( 'simple-scroller__arrow_hidden', rowScrollLeft+rowWidth >= inner.width() )
            });
        },

        brokersAddressCitiesSearchTimeout: null,

        brokersAddressCitiesSearchGetResults: function () {
            let INPUT = $(this),
                STRING = INPUT.val(),
                resultBlock = $('#js-brokers-addresses-search-result');

            if (STRING.length > 1) {

                if (app.brokersAddressCitiesSearchTimeout) { //timeout_clear();
                    clearTimeout(app.brokersAddressCitiesSearchTimeout);
                }

                app.brokersAddressCitiesSearchTimeout = setTimeout(function(){

                    $.ajax({
                        type: 'get',
                        dataType: 'json',
                        // headers: {"X-Requested-With": "NULL"},
                        url: INPUT.attr('data-route'),
                        data: {search: STRING},
                        success: function (data) {
                            console.log(data);
                                resultBlock
                                    .empty()
                                    .append(data.html)
                                    .show();
                        },
                        complete: function () {

                            $(document).mouseup(function (e){
                                if (!resultBlock.is(e.target) // если клик был не по нашему блоку
                                    && resultBlock.has(e.target).length === 0) { // и не по его дочерним элементам
                                    resultBlock.hide(); // скрываем его
                                }
                            });
                        }
                    });

                    return true;

                }, 200); //timeout_set();

            }
            if (STRING.length === 0) {
                resultBlock
                    .empty()
                    .hide();
            }

        },

        onIndexLinkClick: function () {
            $('#indexCollapse').collapse('hide');
        },

        onScrollToCommentsClick: function (e) {
            e.preventDefault();
            $('#js-comments-add').show();
            $('#js-feedback-add').show();

            let comment_user_name = $('#comment-user-name');
            let comment_user_email = $('#comment-user-email');
            let comment_content = $('#comment-content');
            let comment_pluses = $('#comment-pluses');
            if ( comment_user_name.length ) {
                comment_user_name.trigger('focus')
            } else if ( comment_user_email.length ) {
                comment_user_email.trigger('focus')
            } else if ( comment_content.length ) {
                comment_content.trigger('focus')
            } else if ( comment_pluses.length ) {
                comment_pluses.trigger('focus')
            }

            return false;
        },

        showHeaderSearchForm: function () {
            app.header_search_in_focus = true;
            $('#js-header-search').addClass('header-search_expanded');

            onClickOutside('#js-header-search', app.hideHeaderSearchForm);

            $('#js-header-search__form-input').focus();
        },

        hideHeaderSearchForm: function () {
            app.header_search_in_focus = false;
            $('#js-header-search').removeClass('header-search_expanded');
            $('#js-header-search__results').hide();
        },

        toggleHeaderSearchForm: function () {
            if (app.header_search_in_focus) {
                app.hideHeaderSearchForm();
            } else {
                app.showHeaderSearchForm();
            }
        },

        onHeaderSearchFormButtonClick: function (e) {
            if (!app.header_search_in_focus) {
                app.showHeaderSearchForm();

                e.preventDefault();
            }
        },

        onHeaderSearchFormSubmit: function (e) {
            if ( !$('#js-header-search__form-input').val() ) {
                e.preventDefault();
            }

            // // делаем запрос и показываем результаты
            // $('#js-header-search__results').show();
        },

        toggleIdeasListItemDesc: function () {

            let btn = $(this),
                btnOldText = btn.text(),
                btnNewText = btn.attr('data-text-toggle'),
                target = btn.attr('data-target-id');

            btn.attr('data-text-toggle', btnOldText).text(btnNewText);

            $('#'+target).toggle();
        },

        loadMoreItems: function () {
            let btn = $(this),
                url = btn.attr('data-url'),
                base = btn.attr('data-base'),
                item = btn.attr('data-item'),
                category = btn.attr('data-category'),
                text = btn.attr('data-text'),
                loading = btn.attr('data-loading'),
                wrapper = btn.attr('data-wrapper'),
                page = +btn.attr('data-page') + +1,
                sortBy = btn.attr('data-sort-by'),
                sortTo = btn.attr('data-sort-to'),
                last_page = +btn.attr('data-lastpage');

            btn.html(loading).attr('disabled', 'disabled');

            $.ajax({
                type: 'get',
                url: url ? url : ('/' + base + '/get_items_list'),
                data: {
                    item: item ? item : undefined,
                    category: category ? category : undefined,
                    page: page ? page : undefined,
                    sort_by: sortBy ? sortBy : undefined,
                    sort_to: sortTo ? sortTo : undefined,
                },
                success: function (data) {
                    $(wrapper).append(data);
                    btn.attr('data-page', page);

                    if(last_page == page) {
                        if ( btn.parent('.common-more-wrap').length ) {
                            btn.parent('.common-more-wrap').remove();
                        } else {
                            btn.remove();
                        }
                    }

                    btn.html(text).removeAttr('disabled');
                },
                error: function (data) {
                },
                complete: function () {
                }
            });
        },

        rateIdea: function () {
            let btn = $(this),
                item_id = btn.attr('data-item-id'),
                rate_mode = btn.attr('data-rate'),
                rates_block = btn.closest('.js-idea-rates');

            rates_block.removeClass('idea-show-rates_interactive');
            rates_block.addClass('idea-show-rates_disabled');

            $.ajax({
                type: 'post',
                data: {
                    item_id: item_id,
                    like: rate_mode === 'up' ? 1 : -1
                },
                dataType: 'json',
                url: '/ideas/likes/store',
                success: function (data) {
                    if (data.success) {
                        rates_block.replaceWith(data.html);
                    }
                },
                error: function (data) {
                },
                complete: function () {
                }
            });
        },

        onPollFormSubmit: function (e) {
            e.preventDefault();

            let form = $(this),
                action = form.attr('action'),
                poll = form.closest('.js-poll-body')
            ;

            form.addClass('form-poll_disabled');

            $.ajax({
                type: 'post',
                data: form.serialize(),
                dataType: 'json',
                url: action,
                success: function (data) {
                    if (data.success) {
                        poll.replaceWith(data.html);
                    }
                },
                error: function (data) {
                    form.removeClass('form-poll_disabled');
                },
                complete: function () {
                }
            });
        },

        toggleCommentAddForm: function () {
            $('#js-comments-add').toggle();
        },

        toggleCommentAnswerForm: function () {
            let btn = $(this);

            btn.next('.js-comments-list-item__add-answer-form').toggle();
        },

        toggleFeedbackAddForm: function () {
            $('#js-feedback-add').toggle();
        },

        toggleFeedbackAnswerForm: function () {
            let btn = $(this);

            btn.next('.js-feedback-list-item__add-answer-form').toggle();
        },

        ratingStarMouseEnter: function() {
            let star = $(this),
                rate = star.attr('data-rate'),
                rating = star.closest('.js-rating-stars');

            rating.attr('data-rating-hover', rate);
        },

        ratingStarMouseLeave: function() {
            let rating = $(this).closest('.js-rating-stars');

            rating.removeAttr('data-rating-hover');
        },

        ratingFormStarClick: function() {
            let star = $(this),
                rate = star.attr('data-rate'),
                rating = star.closest('.js-rating-stars');

            rating.attr('data-rating', rate)
                .removeAttr('data-rating-hover');

            $('#js-rating-form__input').val(rate);
        },

        ratingArticleStarClick: function() {
            let star = $(this),
                rate = star.attr('data-rate'),
                base = star.parent().attr('data-url-base'),
                rating = star.closest('.js-rating-stars'),
                item_id = $('#js_stars_item_id').val();

            rating.attr('data-rating', rate)
                .removeAttr('data-rating-hover')
                .addClass('rating-stars_disabled')
                .removeClass('rating-stars_interactive')
            ;

            $.ajax({
                type: 'post',
                data: {
                    item_id: item_id,
                    stars: rate
                },
                url: '/' + base + '/likes/store',
                success: function (data) {
                    $('#js_article-show__feedback__stars_wrapper').empty().append(data);
                },
                error: function (data) {
                },
                complete: function () {
                }
            });
        },

        commentRateClick: function() {
            let button     = $(this),
                block      = button.parent(),
                comment_id = button.attr('data-comment-id'),
                sign       = button.attr('data-sign'),
                action     = button.attr('data-action'),
                count      = parseInt(button.text())
            ;

            block.addClass('comments-list-item__rates_disabled');

            $.ajax({
                type: 'post',
                data: {
                    comment_id: comment_id,
                    sign: sign
                },
                url: action,
                success: function (data) {
                    if (data.success) {
                        count++;
                        button.text(count);
                    }
                },
                error: function () {
                    block.removeClass('comments-list-item__rates_disabled');
                },
                complete: function () {
                }
            });
        },

        ipoVoteClick: function() {
            let button     = $(this),
                block      = $('#js-ipo-votes-bar'),
                item_id    = button.attr('data-item-id'),
                sign       = button.attr('data-sign'),
                action     = button.attr('data-action')
            ;

            $('.js-ipo-votes-bar__button').addClass('disabled');

            $.ajax({
                type: 'post',
                data: {
                    item_id: item_id,
                    sign: sign
                },
                url: action,
                success: function (data) {
                    if (data.success) {
                        block.replaceWith(data.html);
                    }
                },
                error: function () {
                    $('.js-ipo-votes-bar__button').removeClass('disabled');
                },
                complete: function () {
                }
            });
        },

        etfVoteClick: function() {
            let button     = $(this),
                block      = $('#js-etf-votes-bar'),
                item_id    = button.attr('data-item-id'),
                sign       = button.attr('data-sign'),
                action     = button.attr('data-action')
            ;

            $('.js-etf-votes-bar__button').addClass('disabled');

            $.ajax({
                type: 'post',
                data: {
                    item_id: item_id,
                    sign: sign
                },
                url: action,
                success: function (data) {
                    if (data.success) {
                        block.replaceWith(data.html);
                    }
                },
                error: function () {
                    $('.js-etf-votes-bar__button').removeClass('disabled');
                },
                complete: function () {
                }
            });
        },

        showEtfContent: function() {
            let button     = $(this),
                block      = $('#js-etf-content')
            ;

            button.hide();

            block.show();
        },

    };

    app.initialize();

    function onClickOutside(selector, callback) {
        const outsideClickListener = (event) => {
            const $target = $(event.target);
            if (!$target.closest(selector).length) {

                callback.call(this);

                removeClickListener();
            }
        }

        const removeClickListener = () => {
            document.removeEventListener('click', outsideClickListener)
        }

        document.addEventListener('click', outsideClickListener)
    }

});
